import { Offcanvas, Collapse, Dropdown, Modal, Tooltip } from 'bootstrap';
window.Modal = Modal;
window.Collapse = Collapse;
window.Dropdown = Dropdown;
window.Tooltip = Tooltip;

import './scripts.js';

export default {
  Offcanvas,
  Collapse,
  Dropdown,
  Modal,
}


